import { render, staticRenderFns } from "./PollAlreadySubmitted.vue?vue&type=template&id=0728fc30&"
import script from "./PollAlreadySubmitted.vue?vue&type=script&lang=js&"
export * from "./PollAlreadySubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports